import { render, staticRenderFns } from "./Gamification.vue?vue&type=template&id=629a9fbc&scoped=true"
import script from "./Gamification.vue?vue&type=script&lang=js"
export * from "./Gamification.vue?vue&type=script&lang=js"
import style0 from "./Gamification.vue?vue&type=style&index=0&id=629a9fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629a9fbc",
  null
  
)

export default component.exports